module.exports = ".right {\n  float: right;\n  width: 2%; }\n\n.mat-icon {\n  float: right;\n  color: white; }\n\na {\n  text-decoration: none; }\n"